module.exports = __webpack_public_path__ + "img/aboutus_img.9c4b749c.png";